import "./ConsentManagement.scss";

import React from "react";
import { Trans, useTranslation } from "react-i18next";

const ConsentManagement: React.FC = () => {
    const { t } = useTranslation();

    const handlePrivacySettingsClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        if (window.UC_UI && typeof window.UC_UI.showSecondLayer === "function") {
            window.UC_UI.showSecondLayer();
        } else {
            console.warn("UC_UI.showSecondLayer is not available");
        }
    };

    return (
        <section className="consentManagementSection">
            <small>
                <Trans i18nKey="By continuing this service, you agree to our data protection policy">
                    By continuing this service, you agree to our <a href={t("data_protection_link")} target="_blank" rel="noopener noreferrer">data protection policy</a>.
                    You can adjust your <a href="#" onClick={handlePrivacySettingsClick}>privacy settings</a> at any time.
                </Trans>
            </small>
        </section>
    );
};

export default ConsentManagement;
